import { useState } from "react";
import { Instagram, Menu as MenuIcon, Music2, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { navItems } from "@/constants/nossaData";
import { useEventPopup } from "@/hooks/useEventPopup";
import { CookieBanner } from "./CookieBanner";
import { EventPromoPopup } from "./EventPromoPopup";
import { LogoMark } from "./LogoMark";

export const SiteFrame = ({ children, contact }) => {
  const [open, setOpen] = useState(false);
  const { showEventPopup, closeEventPopup } = useEventPopup();

  return (
    <div className="site-shell">
      <div className="ambient-photo" aria-hidden="true" />
      <Header open={open} onToggle={() => setOpen((value) => !value)} />
      {open && <MobileNavigation onClose={() => setOpen(false)} />}
      <main data-testid="main-content">{children}</main>
      <Footer contact={contact} />
      <CookieBanner />
      {showEventPopup && <EventPromoPopup onClose={closeEventPopup} />}
    </div>
  );
};

const Header = ({ open, onToggle }) => (
  <header className="site-header" data-testid="site-header">
    <LogoMark location="header" />
    <DesktopNavigation />
    <HeaderSocialActions />
    <button className="mobile-menu-button" data-testid="mobile-menu-toggle-button" onClick={onToggle} aria-label="Abrir menú">
      {open ? <X size={22} /> : <MenuIcon size={22} />}
    </button>
  </header>
);

const DesktopNavigation = () => (
  <nav className="desktop-nav" data-testid="desktop-navigation">
    {navItems.map((item) => (
      <NavLink key={item.path} to={item.path} data-testid={item.testId} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
        {item.label}
      </NavLink>
    ))}
  </nav>
);

const HeaderSocialActions = () => (
  <div className="header-social-actions" data-testid="header-social-actions">
    <Button asChild className="reserve-button social-button" data-testid="header-instagram-button">
      <a href="https://www.instagram.com/nossabarcafe" target="_blank" rel="noreferrer" aria-label="Instagram de Nossa">
        <Instagram size={17} /> Instagram
      </a>
    </Button>
    <Button asChild className="reserve-button social-button" data-testid="header-tiktok-button">
      <a href="https://www.tiktok.com/@nossabarcafe" target="_blank" rel="noreferrer" aria-label="TikTok de Nossa">
        <Music2 size={17} /> TikTok
      </a>
    </Button>
  </div>
);

const MobileNavigation = ({ onClose }) => (
  <div className="mobile-nav" data-testid="mobile-navigation">
    {navItems.map((item) => (
      <NavLink key={item.path} to={item.path} data-testid={`mobile-${item.testId}`} onClick={onClose}>
        {item.label}
      </NavLink>
    ))}
  </div>
);

const Footer = ({ contact }) => (
  <footer className="site-footer" data-testid="site-footer">
    <LogoMark compact location="footer" />
    <p data-testid="footer-slogan">Tu lugar. Tu pausa. Tu momento.</p>
    <div className="footer-link-groups" data-testid="footer-link-groups">
      <div className="footer-legal-links" data-testid="footer-legal-links">
        <Link to="/aviso-legal" data-testid="footer-legal-notice-link">Aviso Legal</Link>
        <Link to="/politica-privacidad" data-testid="footer-privacy-policy-link">Política de Privacidad</Link>
        <Link to="/politica-cookies" data-testid="footer-cookie-policy-link">Política de Cookies</Link>
      </div>
      <div className="footer-social-links" data-testid="footer-social-links">
        <a href="https://www.instagram.com/nossabarcafe" target="_blank" rel="noreferrer" data-testid="footer-instagram-link">Instagram {contact.instagram}</a>
        <a href="https://www.tiktok.com/@nossabarcafe" target="_blank" rel="noreferrer" data-testid="footer-tiktok-link">TikTok {contact.tiktok || contact.instagram}</a>
      </div>
    </div>
  </footer>
);